const categories = {
  'clothing': {
    "id": "11f4f615-d181-4f63-a340-5c534e7fc8b7",
    "name": "clothing",
    "imageUrl": null
  },
  'jewelry': {
    "id": "2c7fff96-91ce-4e94-b694-4a91b5dc8ac6",
    "name": "jewelry",
    "imageUrl": null
  },
  'fabrics': {
    "id": "3b3893bc-1094-418c-8706-867adbeb5e3f",
    "name": "fabrics",
    "imageUrl": null
  },
  'accessory': {
    "id": "4752120a-2fea-4215-8e22-a29af4e93bf1",
    "name": "accessory",
    "imageUrl": null
  },
  'art': {
    "id": "993f9a13-fd40-4c9f-a1cb-0f687b196844",
    "name": "art",
    "imageUrl": null
  },
  'craft': {
    "id": "9dd7aa5d-6c12-4ea3-8755-cafe322036e0",
    "name": "craft",
    "imageUrl": null
  },
  'gifts': {
    "id": "c97f05d3-d28f-4ec2-a6b5-654b33ba9212",
    "name": "gifts",
    "imageUrl": null
  },
  'more': {
    "id": "d613ce48-c2cc-4a8b-906d-6d8a40baa90d",
    "name": "more",
    "imageUrl": null
  }
}

export { categories }
